import { Component, OnInit } from '@angular/core';
import { LessonListService } from 'src/app/core/http/lessonList/lesson-list.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Subscribable, Subscription } from 'rxjs';

@Component({
  selector: 'app-lesson-theory',
  templateUrl: './lesson-theory.component.html',
  styleUrls: ['./lesson-theory.component.css']
})
export class LessonTheoryComponent implements OnInit {
  lesson_id: string;
  NavEnd: Subscription;
  navData = [];
  lesson_theory = null;
  constructor(private route: ActivatedRoute, private router: Router, private lessonListService: LessonListService) {
    this.NavEnd = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.lesson_theory = null;
        this.lesson_id = this.route.snapshot.paramMap.get("lesson");
        this.getTheory();
      }
    })
    
    
  }

  ngOnInit(): void {
  }

  getTheory() {
    this.lessonListService.GetTheory(this.lesson_id)
    .subscribe((res:any) => {
      console.log(res);
      this.navData = JSON.parse(res.data);
      this.lesson_theory = res;
    });
  }

  PrevLesson(lessons) {
    var index = lessons.findIndex(x => x.cr === true);
    var prevI = index - 1;
    if (lessons[prevI]) {
      return lessons[prevI].id;
    } else {
      return false;
    }
  }
  NextLesson(lessons) {
    var index = lessons.findIndex(x => x.cr === true);
    var nextI = index + 1;
    if (lessons[nextI]) {
      return lessons[nextI].id;
    } else {
      return false;
    }
  }
  CompetedLessons(lessons) {
    var completed = lessons.filter(x => x.tp == x.tt)
    return completed.length;
  }
  CurrentLessonPercent(lessons) {
    var current = lessons.filter(x => x.cr === true);
    return (current[0].tp/current[0].tt)*100;
  }

}
